import { pList, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rGrupSirketDegerlemeUstBilgi } from '../../../../api/models/rGrupSirketDegerlemeUstBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_GRUPSIRKETDEGERLEMEUSTBILGI,
    new Api.Bilgi.GrupSirketDegerlemeUstBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rGrupSirketDegerlemeUstBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rGrupSirketDegerlemeUstBilgi> =>
  ActionFunctions.action_async_complete_api<rGrupSirketDegerlemeUstBilgi>(
    ActionSubTypes.API_GRUPSIRKETDEGERLEMEUSTBILGI,
    data?.Value,
    error
  );
